import { useMutation, UseMutationOptions } from 'react-query';

import { userApi } from 'src/Services/API';
import { UpdateUserUtmDto, UserDto } from 'src/Services/API/generated';

export const useUpdateUserUtm = (
  options?: UseMutationOptions<UserDto, unknown, UpdateUserUtmDto>
) => {
  return useMutation<UserDto, unknown, UpdateUserUtmDto>(
    'update-user-utm',
    async data => {
      const response = await userApi.userControllerUpdateUserUtm(data);
      return response.data;
    },
    options
  );
};
